var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePlaySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.77,
    height: 22.9,
    viewBox: "0 0 21.77 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-play-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,17.9A5.1,5.1,0,1,1,17.9,23,5.12,5.12,0,0,1,12.8,17.9Zm.8,0a4.3,4.3,0,1,0,4.3-4.3A4.27,4.27,0,0,0,13.6,17.9Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,23.3l-1-1a.35.35,0,0,1,.5-.5l1,1a.45.45,0,0,1,0,.5.37.37,0,0,1-.3.1C22.9,23.4,22.9,23.4,22.8,23.3Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,17.1C7.2,17.1,6,15.9,6,13.2v-3C6,7.5,7.2,6.3,9.9,6.3h3c2.7,0,3.9,1.2,3.9,3.9v3c-1.2-.3-4,3.8-3.9,3.9ZM6.7,10.2v3c0,2.3.8,3.2,3.2,3.2h3a16.17,16.17,0,0,0,3.2-3.2v-3c0-2.3-.8-3.2-3.2-3.2h-3C7.6,7,6.7,7.8,6.7,10.2Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,9.7a1.4,1.4,0,1,1,1.4,1.4A1.5,1.5,0,0,1,8.5,9.7Zm.8,0a.6.6,0,1,0,.6-.6C9.5,9,9.3,9.3,9.3,9.7Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,15.3c-.1-.2-.1-.4.1-.5h0l2.4-1.6a1.36,1.36,0,0,1,1.7.1l.2.1a.75.75,0,0,0,.9,0l2-1.8a1.5,1.5,0,0,1,1.8,0l.8.7c.1.1.2.4,0,.5a.28.28,0,0,1-.5,0l-.8-.7a.75.75,0,0,0-.9,0l-2,1.8a1.5,1.5,0,0,1-1.8,0l-.2-.1a.61.61,0,0,0-.8,0L7.2,15.4c-.1,0-.1.1-.2.1S6.7,15.4,6.7,15.3Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_96",
    "data-name": "Capa 96"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.2,4.5A3.37,3.37,0,0,1,5.6,1.1a3.35,3.35,0,1,1,0,6.7A3.35,3.35,0,0,1,2.2,4.5Zm.5,0A2.9,2.9,0,1,0,5.6,1.6,2.9,2.9,0,0,0,2.7,4.5Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,5.6a.78.78,0,0,1-.3-.7V4A.78.78,0,0,1,5,3.3a.8.8,0,0,1,.8.1l.7.4c.3.2.5.4.5.7a.74.74,0,0,1-.5.6l-.7.4c-.2.1-.3.2-.5.2A.37.37,0,0,1,5,5.6Zm.2-1.9c-.1,0-.2.1-.2.3v.9a.52.52,0,0,0,.2.4c.1.1.2,0,.4-.1l.7-.4c.2-.1.2-.2.2-.3s-.1-.2-.2-.3l-.7-.5c-.1,0-.2-.1-.3-.1A.1.1,0,0,0,5.2,3.7Z",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.9 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaySearch);
export default __webpack_public_path__ + "static/media/image-play-search.6625ef23f1d12c2908c4fbbaa2b68179.svg";
export { ForwardRef as ReactComponent };